import { Text, View } from "dripsy";
import * as React from "react";

function Error({
  isError,
  error,
  paddingTop,
  paddingBottom,
}: {
  isError: boolean;
  error: any;
  paddingTop?: string;
  paddingBottom?: string;
}) {
  if (!isError) {
    return null;
  }

  return (
    <View>
      <Text
        sx={{
          color: "$error",
          paddingTop,
          paddingBottom,
          fontWeight: "500",
        }}
      >
        {isString(error) || isString(error?.message) ? error?.message || error : "Er is iets misgegaan"}
      </Text>
    </View>
  );
}

function isString(e: any): e is string {
  return typeof e === "string";
}
export default Error;
